import { css } from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { getLogo } from '@zocdoc/branding/brands/helpers';

export const getLogoSizingAtBreakpoint = (theme, breakpointName) => {
    const tuple = getLogo(theme).sizing[breakpointName];

    if (!tuple) {
        return {};
    }

    return {
        height: tuple[0],
        width: tuple[1],
    };
};

export const getLogoSizingCSSAtBreakpoint = (theme, breakpointName) => {
    const { height, width } = getLogoSizingAtBreakpoint(theme, breakpointName);

    if (!height && !width) {
        return '';
    }

    return css`
        ${breakpoint[breakpointName]} {
            height: ${height}px;
            width: ${width}px;
        }
    `;
};
